import vs from './project2.vertex.glsl';
export default {
  name: 'project2',
  vs: vs,
  fs: vs
};
//# sourceMappingURL=project2.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/modules/project2/project2.js
// module id = 1584
// module chunks = 0